import type { AutomaticProxyCountry } from '@api'
import * as z from 'zod'

/** The values that are handled within the form context */
export type AddCreatorFormValues = Omit<
  z.infer<typeof CreatorAddFormSchema>,
  'automaticProxyCountry'
> & { automaticProxyCountry: AutomaticProxyCountry }

export const CreatorAddFormSchema = z.object({
  url: z
    .string()
    .min(1, { message: 'Username is required' })
    .regex(/^[^/?#\s]+$/, {
      message:
        'Username cannot contain spaces, forward slashes, question marks, or hash symbols',
    }),
  automaticProxyCountry: z
    .string({
      required_error: 'Proxy country is required',
    })
    .min(1),
})

export const defaultValues: AddCreatorFormValues = {
  url: '',
  // @ts-ignore
  automaticProxyCountry: '',
}
